import getURLSearchParam from './base/url'
import { E_ProcessEnv, getAppEnv, getProcessEnv } from './base/env'
import http from './axios/index'
import { CustomResponeData } from 'axios'
import { reportError } from './owl'

export interface DEFAULT_THEME {
  globalStyle?: string
  key: string
}

export type THEME<T> = DEFAULT_THEME & T

function processData(data: Record<string, any>): Record<string, any> {
  for (const i of Object.keys(data)) {
    if (typeof data[i] === 'object') {
      data[i] = processData(data[i])
    }
    if (i.indexOf(':') !== -1) {
      const [env, key] = i.split(':')
      if (key && env === getAppEnv()) {
        data[key] = data[i]
        delete data[i]
      }
    }
  }
  return data
}

const API_HOST: Record<string, string> = {
  prod: 'https://api-phx.meituan.com',
  test: 'http://gw.ia.test.sankuai.com',
}

interface ServerTheme<T> {
  jsonData: THEME<T>
}
// http: op.ia.st.sankuai.com/tools/ui/themes
const getTheme = <T>(tempKey: string, instanceKey: string): Promise<THEME<T>> => {
  return http
    .post<CustomResponeData<ServerTheme<T>>>(
      `${API_HOST[process.env.VUE_APP_PW_ENV || 'prod']}/marketing/api/v1/pwStyle/getPwActStyle`,
      {
        tempKey,
        instanceKey,
      },
    )
    .then((res) => {
      if (res && res.jsonData) {
        const jsonData = processData(res.jsonData) as T
        return {
          ...jsonData,
          key: instanceKey,
          arrayData: Array.isArray(res.jsonData) ? jsonData : undefined,
        }
      }
      if (instanceKey !== 'default') {
        return getTheme<T>(tempKey, 'default')
      }
      throw { status: -1, message: '配置加载失败' }
    })
}

async function themes<T>(defaultPageConfigs = {}, tempKey: string, instanceKey: string): Promise<THEME<T>> {
  const theme: THEME<T> = await getTheme(tempKey, instanceKey)
  return {
    ...defaultPageConfigs,
    ...theme,
  }
}

export function configGlobalStyle(style?: string) {
  if (style) {
    try {
      const globalStyle = document.createElement('style')
      globalStyle.innerText = style
      document.head.appendChild(globalStyle)
    } catch (err) {
      reportError({ name: '主题配置错误', msg: err })
    }
  }
}

export default async function <T>(
  defaultPageConfigs = {},
  tempKey = getProcessEnv(E_ProcessEnv.VUE_APP_TEMPLATE_KEY) ||
    (getProcessEnv(E_ProcessEnv.VUE_APP_PROJECT_NAME) || '').toUpperCase(),
  instanceKey = getURLSearchParam('theme') || 'default',
): Promise<THEME<T>> {
  try {
    const theme: THEME<T> = await themes(defaultPageConfigs, tempKey, instanceKey)
    // console.log('[theme]', theme)
    configGlobalStyle(theme.globalStyle)
    return theme
  } catch (e: any) {
    if (e && e.status && e.message) throw e
    throw { status: -1, message: '配置加载失败，请尝试重新访问' }
  }
}
